import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.7012 8.83402C10.9186 8.83402 10.2842 8.19961 10.2842 7.41701C10.2842 6.63442 10.9186 6 11.7012 6C12.4838 6 13.1182 6.63442 13.1182 7.41701C13.1182 8.19961 12.4838 8.83402 11.7012 8.83402ZM11.2827 15.1107V12.1404H9.59927C9.07754 12.1404 8.6546 11.7174 8.6546 11.1957C8.6546 10.674 9.07754 10.251 9.59927 10.251H12.2274C12.7491 10.251 13.1721 10.674 13.1721 11.1957V15.1107H15.0553C15.5771 15.1107 16 15.5336 16 16.0553C16 16.5771 15.5771 17 15.0553 17H9.33954C8.81781 17 8.39487 16.5771 8.39487 16.0553C8.39487 15.5336 8.81781 15.1107 9.33954 15.1107H11.2827Z"
  }));
});
var NotificationInfo = AbstractIcon.withComponent(Icon);
NotificationInfo.displayName = 'NotificationInfo';
export default NotificationInfo;